import { useState, useEffect } from 'react';
import { message } from 'antd';
import { p9513Api, DashboardResponse } from '../../../services/p9513Api';

export function useDashboard() {
  const [loading, setLoading] = useState(false);
  const [dashboard, setDashboard] = useState<DashboardResponse>({
    pending_leave_count: 0,
    pending_trip_count: 0,
  });

  const fetchDashboard = async () => {
    setLoading(true);
    try {
      const data = await p9513Api.getDashboard();
      setDashboard(data);
    } catch {
      message.error('無法載入儀表板資料');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboard();
  }, []);

  return { loading, dashboard, fetchDashboard };
}
